import React, { useState, useEffect, useRef } from "react"

import filterStyles from './table_filter.module.scss'
import FilterType from "./filter_type"


const TableFilter = ({ filters }) => {

    // open and closing drop down//
    const [filterOpen, setFilterOpen] = useState(false)

    const handleOpenState = (e) => {
        setFilterOpen(!filterOpen)
    }

    // handling outside clicks //
    // https://stackoverflow.com/questions/32553158/detect-click-outside-react-component?answertab=votes#tab-top // 
    function useOutsideCloser(ref) {
        useEffect(() => {
            // close if clicked outside //
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    // if clicked element is the filter button, let it handle //
                    if (!['filterButton', 'filterSpanOne', 'filterSpanTwo'].includes(event.target.id)) {
                        setFilterOpen(false);
                    }
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    // create reference //
    const wrapperRef = useRef(null);
    useOutsideCloser(wrapperRef);

    // get active number of filters //
    var activeFilters = 0

    filters.forEach((filter) => {
        // get filter type to know how to check it //
        const filterValueTypes = typeof filter['filterParams']['values']

        if (filterValueTypes === 'object' || filterValueTypes === 'string') {
            if (filter['filterParams']['values'].length > 0) {
                activeFilters = activeFilters + 1
            }
        } else if (['number', 'bigint'].includes(filterValueTypes)) {
            if (filter['filterParams']['values'] > 0) {
                activeFilters = activeFilters + 1
            }
        }
    })

    // filters states are set in the parent, then the set functions and options are passed to //
    // this filter component, which is really just a container for defining how they render//
    // then a seperate component reads passed filters and conditionally creates the correct HTML //
    // similar to how table component has display types //
    // this creates consistent visuals and cleaner html //

    return (
        
        <div className={filterStyles.dropWrapper}>
            <div className={filterStyles.dropContainer}>
                <button
                    className={filterStyles.dropButton}
                    data-active={filterOpen}
                    onClick={handleOpenState}
                    id={'filterButton'}
                >
                    <span
                        id={'filterSpanOne'}    
                    >
                        Filter
                    </span>
                    <span
                        className={filterStyles.filtersActiveSpan}
                        data-active={activeFilters > 0 ? true : false}
                        id={'filterSpanTwo'}
                    >
                        {activeFilters > 0 ? activeFilters : `\u236B`}
                    </span>
                </button>
                <div 
                    className={filterStyles.dropMenu}
                    data-active={filterOpen}
                    ref={wrapperRef}
                >
                    {filterOpen ?
                        filters.map(filter => {
                            return(
                                <FilterType
                                    key={filter['filterId']}
                                    filterType={filter['filterType']}
                                    filterName={filter['filterName']}
                                    filterParams={filter['filterParams']}
                                />
                            )
                        }) :
                        null
                    }
                </div>
            </div>    
        </div>
    )
}

export default TableFilter

